import MyDemos from "./demos";
import "./index.css";

export function App() {
  return <MyDemos />;
}
